import { Action, createHook, createStore } from 'react-sweet-state'

import { postRegister } from '../api/login'
import { deleteUser, putUser } from '../api/users'
import { IRoleEnum } from '../types/router'

export interface IUser {
    _id: string
    username: string
    email: string
    role: IRoleEnum
}

interface UsersState {
    users: IUser[]
}

const usersInitialState: UsersState = {
    users: [],
}

const usersActions = {
    setUsers:
        (users: IUser[]): Action<UsersState> =>
        ({ setState }) => {
            setState({
                users,
            })
        },
    deleteUser:
        (id: string): Action<UsersState> =>
        ({ setState, getState }) => {
            deleteUser(id)

            setState({
                users: getState().users.filter((user) => user._id !== id),
            })
        },
    addUser:
        (
            username: string,
            email: string,
            password: string,
            role: IRoleEnum
        ): Action<UsersState> =>
        async ({ setState, getState }) => {
            const _id = await postRegister(
                username,
                email,
                password,
                role
            ).then((res) => res.data as string)

            setState({
                users: [{ _id, username, email, role }, ...getState().users],
            })
        },
    editUser:
        (id: string, role: IRoleEnum): Action<UsersState> =>
        ({ setState, getState }) => {
            putUser(id, role)

            const { users } = structuredClone(getState())
            const userToEdit = users.find((user) => user._id === id)

            if (!userToEdit) return

            userToEdit.role = role
            setState({ users })
        },
}

const Store = createStore({
    initialState: usersInitialState,
    actions: usersActions,
})

export const useUsersStore = createHook(Store)
